import $http from './http'
import config from './config'

export default {
    name: 'bill',
    getUrl(url) {
        return config.getUrl(this.name, url);
    },
    CreateTrade(data) {
        return $http.post(this.getUrl(`/TradeDeal/CreateTrade`), data);
    },
    SubmitTrade(TradeID) {
        return $http.get(this.getUrl(`/TradeDeal/SubmitTrade?TradeID=${TradeID}`));
    },
    getTradeDeals(data) {
        return $http.post(this.getUrl(`/TradeDeal/GetTradeDeals`),data);
    },
    saveTradeDeal(data) {
        return $http.post(this.getUrl('/tradedeal/update'), data)
    },
    ConfirmTrade(data) {
        return $http.post(this.getUrl('/TradeDeal/ConfirmTrade'), data);
    },
    CreateInvoice(data) {
        return $http.post(this.getUrl('/TradeDeal/CreateInvoice'), data)
    },
    TradeStatusStatistics(data) {
        return $http.post(this.getUrl('/TradeDeal/TradeStatusStatistics'), data)
    },
    UpdateTradeDetailPrice(data) {
        return $http.post(this.getUrl(`/TradeDetail/UpdateTradeDetailPrice`), data);
    },
    GetUserPayment(orderid, unionid) {
        return $http.get(this.getUrl(`/TradeDeal/GetUserPayment?OrderID=${orderid}&UnionID=${unionid}`));
    },
    UpdateTradeOrder(data) {
        return $http.post(this.getUrl(`/TradeOrder/Update`), data);
    },
    // getTradeOrderList(data) {
    //     return $http.post(this.getUrl(`/TradeOrder/list`), data);
    // },
    getTradeOrder(id) {
        return $http.get(this.getUrl(`/TradeOrder/details/${id}`));
    },
    CancelTrade(id){
        return $http.get(this.getUrl(`/TradeDeal/CancelTrade/${id}`))
    },

    CheckPaymentResult(id){
        return $http.get(this.getUrl(`/TradeOrder/CheckPaymentResult/${id}`));
    },




    getBankAccount(data) {
        return $http.post(this.getUrl(`/BankAccount/List`), data);
    },
    saveBankAccount(data) {
        return $http.post(this.getUrl(`/BankAccount/BankAccountSave`), data);
    },
    deleteBankAccount(id){
        return $http.get(this.getUrl(`/BankAccount/Delete?id=${id}`))
    },
    updateAccountStatus(id) {
        return $http.get(this.getUrl(`/BankAccount/AccountStatusUpdate/${id}`));
    },
    getTradeDealList(data) {
        return $http.post(this.getUrl(`/TradeDeal/List`), data);
    },
    Receivabledetail(id) {
        return $http.get(this.getUrl(`/TradeDeal/Details/${id}`));
    },
    TradeAccounts(data) {
        return $http.post(this.getUrl(`/TradeAccount/List`), data);
    },
    TradeAccountState(id) {
        return $http.get(this.getUrl(`/TradeAccount/TradeAccountStatus/${id}`));
    },
    TradeAccountAdd(data) {
        return $http.post(this.getUrl(`/TradeAccount/TradeAccountAdd`), data);
    },
    CreditMoeuleQuery(id) {
        return $http.get(this.getUrl(`/CreditModule/CreditMoeuleQuery/${id}`));
    },
    CreditMoeuleSave(data) {
        return $http.post(this.getUrl(`/CreditModule/CreditMoeuleSave`), data);
    },
    TradeFreeze(data) {
        return $http.post(this.getUrl(`/TradeFreeze/List`), data);
    },
    TradeFlow(data) {
        return $http.post(this.getUrl(`/TradeFlow/List`), data);
    },
    RechargeTrade(data) {
        return $http.post(this.getUrl(`/TradeDeal/RechargeTrade`), data);
    },




    //账单图片
    uploadImage(data) {
        return $http.post('/uploadfile/images/Upload/Tour/bill', data);
    },
    //账单文件
    uploadfile(data, filetype) {
        return $http.post(`/uploadfile/files/upload/uploadFile/bill?filetype=${filetype}&`, data);
    },
    // getAccountList(data) {
    //     return $http.post(this.getUrl(`/Account/List`), data);
    // },

    applytable(data) {
        return $http.post(this.getUrl(`/PaymentApply/List`), data);
    },
    Applydetail(data) {
        return $http.post(this.getUrl(`/PaymentApply/MergePayApply`), data);
    },
    ConfirmReturn(data) {
        return $http.post(this.getUrl(`/TradeDeal/Confirmed/`), data);
    },
    PaymentDetails(id) {
        return $http.get(this.getUrl(`/TradeDeal/PaymentDetails/${id}`));
    },
    Approvels(data) {
        return $http.post(this.getUrl(`/TradeDeal/AuditDeal`), data);
    },
    Payment(data) {
        return $http.post(this.getUrl(`/TradeDeal/Payment`), data);
    },
    PayOrder(data) {
        return $http.post(this.getUrl(`/TradeDeal/PayforOrder`), data);
    },
    PaymentInfo(orderid) {
        return $http.get(this.getUrl(`/PaymentApply/PaymentInfo?OrderID=${orderid}`));
    },
    getTrades(id) {
        return $http.get(this.getUrl(`/TradeDeal/GetTrades/${id}`));
    },
    BankAccountList(data) {
        return $http.post(this.getUrl('/BankAccount/List'), data);
    },
    BankAccountUpdate(data) {
        return $http.post(this.getUrl('/BankAccount/Save'), data);
    },
    IsEnable(id) {
        return $http.get(this.getUrl(`/BankAccount/IsEnable/${id}`));
    },
    Account(id) {
        return $http.get(this.getUrl(`/BankAccount/GetStatus/${id}`));
    },
    searchpayment(id) {
        return $http.get(this.getUrl(`/BillService/GetPayment/${id}`));
    },
    getloglist(id) {
        return $http.get(this.getUrl(`/BillLog/GetLogList/${id}`))
    },
    updatetrade(data) {
        return $http.post(this.getUrl('TradeDeal/updateVocher'), data);
    },
    RefusePay(data) {
        return $http.post(this.getUrl('/tradedeal/RefusePay'), data)
    },
    Export(data) {
        return $http.post(this.getUrl('/TradeDeal/Export'), data)
    },
    exporttradedetail(data){
        return $http.post(this.getUrl('/tradedetail/export'),data);
    },
    deleteExportFile(id){
        return $http.get(this.getUrl('/tradedetail/DeleteExportFile?id='+id))
    },













    getUserTicketStatus(data){
        return $http.post(this.getUrl('/tradedetail/SearchUserTicket'),data)
    },


    //交易明细
    getTradeDetailList(data) {
        return $http.post(this.getUrl('/TradeDetail/List'), data)
    },
    getTradeDetailUpdate(data) {
        return $http.post(this.getUrl('/TradeDetail/TradeDetailUpdate'), data)
    },
    getTradeDetailGroupBy(data) {
        return $http.post(this.getUrl('/TradeBill/TradeDetailGroupBy'), data)
    },


    getLossCauseUpdate(data) {
        return $http.post(this.getUrl('/TradeDetail/LossCauseUpdate'), data)
    },
    getCostCenterUpdate(data) {
        return $http.post(this.getUrl('/TradeDetail/CostCenterUpdate'), data)
    },
    getInvoiceSave(data) {
        return $http.post(this.getUrl('/TradeDetail/InvoiceSave'), data)
    },
    getTemplateList(data) {
        return $http.post(this.getUrl('/TradeTemplate/TemplateList'), data)
    },
    getTemplateField(data) {
        return $http.post(this.getUrl('/TradeTemplate/TemplateField'), data)
    },
    getTemplateDetail(data) {
        return $http.post(this.getUrl('/TradeTemplate/TemplateDetail'), data)
    },
    getTemplateSave(data) {
        return $http.post(this.getUrl('/TradeTemplate/TemplateSave'), data)
    },
    //应收账期列表
    getTradeBillList(data) {
        return $http.post(this.getUrl('/TradeBill/List'), data)
    },
    //应付账期列表
    getTradePayBillList(data) {
        return $http.post(this.getUrl('/TradeBill/Paymentlist'), data)
    },
    //账单详细时账期列表查询
    getBillList(data) {
        return $http.post(this.getUrl('/TradeBill/BillList'), data)
    },
    getTradeBillUpdate(id) {
        return $http.get(this.getUrl(`/TradeBill/TradeBillUpdate/${id}`))
    },




    getProfitStatistics(data) {
        return $http.post(this.getUrl('/TradeDetail/ProfitStatistics'), data)
    },
    getSalesComparison(data) {
        return $http.post(this.getUrl('/TradeDetail/SalesComparison'), data)
    },
    SalesComparisonUpdates() {
        return $http.get(this.getUrl(`/TradeDetail/SalesComparisonUpdates`))
    },
    getPaymentConfirm(data) {
        return $http.post(this.getUrl(`/tradeOrder/PaymentConfirm`), data)
    },
    getExportList(){
        return $http.get(this.getUrl('/tradedetail/exportlist'));
    },
    gettradeconfiglist(){
        return $http.post(this.getUrl('/tradeconfig/list'));
    },
    savetradeconfig(data){
        return $http.post(this.getUrl('/tradeconfig/save'),data,{failTips:false});
    },
    getbankcardlist(data){
        return $http.post(this.getUrl('/bankcard/list'),data);
    },
    savebankcard(data){
        return $http.post(this.getUrl('/bankcard/save'),data)
    },
    delbankcard(id){
        return $http.get(this.getUrl('/bankcard/delete?id='+id))
    },

    tradeReceiveStatistics(data){
        return $http.post(this.getUrl('/tradedeal/TradeReceiveStatistics'),data)
    },
    getAllAccounts(){
        return $http.get(this.getUrl('/tradeaccount/GetAllAccounts'))
    },

    
}



// WEBPACK FOOTER //
// ./src/apis/billApis.js